//格式化字符串，超出length用省略号表示溢出
let formatStr = (value, length) => {
  if (value === undefined || value === null) {
    return value;
  }
  let val = value
    .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
    .replace(/<[^>]+?>/g, "")
    .replace(/\s+/g, " ")
    .replace(/ /g, " ")
    .replace(/>/g, " ")
    // .replace(/[&nbsp;]/g, "");
    .replace(/&nbsp;/g, "");
  if (val.length <= length) {
    return val;
  } else {
    return val.substring(0, length) + "...";
  }
};

let formatifone = (value) => {
  if (value === undefined || value === null) {
    return value;
  }
  return  value.substr(0, 3) + '****' + value.substr(7, 11);
}

//格式化图片资源   去掉压缩
let formatImg = value => {
  let val = value;
  try {
    val = val.replace(/\?.*/, "");
  } catch {
    val = value;
  }
  return val;
};

let formatSize = bytes => {
  if (bytes === 0) return "0 B";
  let k = 1024;
  let sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let i = Math.floor(Math.log(bytes) / Math.log(k)); //return (bytes / Math.pow(k, i)) + ' ' + sizes[i];
  return (bytes / Math.pow(k, i)).toPrecision(3) + " " + sizes[i];
};

//  转小写
let lower = value => value.toLowerCase();

// 数字转类型
let SchemeType = val => {
  switch (val) {
    case 1:
      return "人才培养方案";
    case 2:
      return "建设标准";
    case 3:
      return "建设目标";
    case 4:
      return "组建逻辑";
    case 5:
      return "专业建设方案";
    default:
      return val;
  }
};

//格式化日期，将秒转换为时分秒

let formatTime = val => {
  let seconds = val % 60; //秒数
  seconds = seconds < 10 ? "0" + seconds : seconds;
  let min = parseInt(val / 60);
  let mins = min % 60; //分
  mins = mins < 10 ? "0" + mins : mins;
  let hour = parseInt(min / 60);
  let hours = hour < 10 ? "0" + hour : hour;

  return hour == 0 ? `${mins}分${seconds}秒` : `${hours}时${mins}分`;
};

export { formatStr, lower, formatTime, formatImg, formatSize, SchemeType,formatifone };
